module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-flex', {
    staticClass: "justify-center text-xs-center",
    attrs: {
      "xs12": "",
      "mt-1": "",
      "mb-1": ""
    }
  }, [_c('h1', {
    staticClass: "app-title font-red animated fadeInRight"
  }, [_vm._v(_vm._s(_vm.title))])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1af6bd67","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ui/Titlecen.vue
// module id = 950
// module chunks = 1